import { render, staticRenderFns } from "./addHousekeepingServ.vue?vue&type=template&id=af4d3b3c&scoped=true"
import script from "./addHousekeepingServ.vue?vue&type=script&lang=js"
export * from "./addHousekeepingServ.vue?vue&type=script&lang=js"
import style0 from "./addHousekeepingServ.vue?vue&type=style&index=0&id=af4d3b3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af4d3b3c",
  null
  
)

export default component.exports